import Blue from '~/core'

new Blue({
  name: 'Wave Bottom',
  selector: '.composition--wave-bottom',
  setup(wave) {
    let element = this.$createElement({
      tag: 'div',
      attributes: {
        class: 'wave__background',
      },
    })
    wave.appendChild(element)
  },
})

new Blue({
  name: 'Wave Top',
  selector: '.composition--wave-top',
  setup(wave) {
    let element = this.$createElement({
      tag: 'div',
      attributes: {
        class: 'wave__background',
      },
    })
    wave.appendChild(element)
  },
})
